import React, { Component } from 'react';
import { string } from 'prop-types';
import { Grid, Message, Pagination } from 'semantic-ui-react';

import getMinistryData from '../components/getMinistryData';
import Feed from '../components/Feed';
import formatEpisodes from '../components/formatEpisodes';

const initialState = { data: [], loading: true, activePage: 1, totalPages: 1 };

class Programs extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };

    this.handlePaginationChange = this.handlePaginationChange.bind(this);
  }

  componentDidMount() {
    const { ministryId, languageId } = this.props;
    const { activePage } = this.state;
    getMinistryData(ministryId, languageId, activePage)
      .then(
        res =>
          res.data.ministry
            ? this.setState({
                loading: false,
                data: res.data.items,
                totalPages: Math.ceil(res.data.total_results / 20),
              })
            : this.setState({ loading: false, err: 'API Fetch Error' })
      )
      .catch(() => this.setState({ loading: false, err: 'API Fetch Error' }));
  }

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage, loading: true });
    const { ministryId, languageId } = this.props;
    getMinistryData(ministryId, languageId, activePage)
      .then(res => this.setState({ loading: false, data: res.data.items }))
      .catch(() => this.setState({ loading: false, err: 'API Fetch Error' }));
  };

  render() {
    const { data, loading, err, activePage, totalPages } = this.state;
    return !err ? (
      <Grid columns={1} stretched>
        <Grid.Column>
          {totalPages > 1 && (
            <Pagination
              pointing
              secondary
              activePage={activePage}
              onPageChange={this.handlePaginationChange}
              totalPages={totalPages}
            />
          )}
        </Grid.Column>
        <Feed items={formatEpisodes(data)} loading={loading} />
        <Grid.Column>
          {totalPages > 1 &&
            !loading && (
              <Pagination
                pointing
                secondary
                activePage={activePage}
                onPageChange={this.handlePaginationChange}
                totalPages={totalPages}
              />
            )}
        </Grid.Column>
      </Grid>
    ) : (
      <Message negative header="Error" content={err} />
    );
  }
}

Programs.propTypes = {
  ministryId: string.isRequired,
  languageId: string.isRequired,
};

export default Programs;



// WEBPACK FOOTER //
// ./src/Routes/Programs.jsx